import { OperationProblem, WorkflowParamsMap, WorkflowStatus } from '@conveyr/shared-types';
import { AxiosInstance } from 'axios';
import baseAxios from '@/helpers/forms/axios';

export interface WorkflowProgress {
    current: number
    description: string | null
    problems: OperationProblem[]
}

export interface Workflow {
    workflowId: string
    runId: string
    startTime: string
    progress: WorkflowProgress
    type: keyof WorkflowParamsMap
    status: WorkflowStatus
}

export default (axios: AxiosInstance = baseAxios): { dispatchWorkflow: <T extends keyof WorkflowParamsMap>(type: T, input: WorkflowParamsMap[T], searchAttributes?: { fba_plan_id?: string; }) => Promise<Workflow>; indexWorkflowsForUser: (userId: number, workflowIds?: string[]) => Promise<Workflow[]>; indexWorkflowsForFbaPlan: (fbaPlanId: string, workflowIds?: string[]) => Promise<Workflow[]>; } => ({
    dispatchWorkflow: async <T extends keyof WorkflowParamsMap>(
        type: T,
        input: WorkflowParamsMap[T],
        searchAttributes?: { fba_plan_id?: string },
    ): Promise<Workflow> => {
        const response = await axios.post<{ data: Workflow }>('/api/workflows/dispatch', {
            type,
            input,
            ...(searchAttributes && { search_attributes: searchAttributes }),
        });

        return response.data.data;
    },

    indexWorkflowsForUser: async (userId: number, workflowIds?: string[]): Promise<Workflow[]> => {
        const response = await axios.get<{ data: Workflow[] }>('/api/workflows', {
            params: {
                workflow_ids: workflowIds,
                search_attributes: { user_id: userId },
            },
        });

        return response.data.data;
    },

    indexWorkflowsForFbaPlan: async (fbaPlanId: string, workflowIds?: string[]): Promise<Workflow[]> => {
        const response = await axios.get<{ data: Workflow[] }>('/api/workflows', {
            params: {
                workflow_ids: workflowIds,
                search_attributes: { fba_plan_id: fbaPlanId },
            },
        });

        return response.data.data;
    },
});
